/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { PageState } from '@myob/myob-widgets';

const MultiplePaymentMessage: React.FC = () => (
    <PageState
        title="You currently have multiple active payment profiles."
        description="To make sure we update the correct one, please contact our support team."
    />
);
export default MultiplePaymentMessage;
